
const Materials = [
  "Silicone",
  "Aluminum",
  "Wood",
  "terStainless Steel",
  "Leather",
  "Brass"
];

export default Materials;